import React, { useState, useEffect } from 'react';
import { Calendar, ChevronDown } from 'lucide-react';
import { 
  AreaChart, 
  Area, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer 
} from 'recharts';

const ChartSection = ({ chartData }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [timeFilter, setTimeFilter] = useState('monthly');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getDisplayData = () => {
    if (!chartData) return [];
    
    if (timeFilter === 'weekly') {
       return (chartData.weekly || []).map((val, i) => ({ name: `Day ${i + 1}`, value: val }));
    }
    if (timeFilter === 'monthly') {
       const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
       return (chartData.monthly || []).map((val, i) => ({ name: months[i], value: val }));
    }
    if (timeFilter === 'yearly') {
       const currentYear = new Date().getFullYear();
       return (chartData.yearly || []).map((val, i) => ({ name: String(currentYear - 4 + i), value: val }));
    }
    return [];
  };

  const displayData = getDisplayData();

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h3 className="chart-title">User Statistics (Players)</h3>
        <div className="chart-filters">
          <div className="time-filter">
            <button 
              className={`filter-btn ${timeFilter === 'weekly' ? 'active' : ''}`}
              onClick={() => setTimeFilter('weekly')}
            >
              Weekly
            </button>
            <button 
              className={`filter-btn ${timeFilter === 'monthly' ? 'active' : ''}`}
              onClick={() => setTimeFilter('monthly')}
            >
              Monthly
            </button>
            <button 
              className={`filter-btn ${timeFilter === 'yearly' ? 'active' : ''}`}
              onClick={() => setTimeFilter('yearly')}
            >
              Yearly
            </button>
          </div>
        </div>
      </div>

      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={displayData} margin={{ top: 10, right: 0, left: isMobile ? -60 : -20, bottom: 0 }}>
            <defs>
              <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#F97316" stopOpacity={0.1}/>
                <stop offset="95%" stopColor="#F97316" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#EFEFEF" />
            <XAxis 
              dataKey="name" 
              hide={false}
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#6F767E', fontSize: 12 }}
            />
            {!isMobile && (
              <YAxis 
                axisLine={false} 
                tickLine={false} 
                tick={{ fill: '#6F767E', fontSize: 12 }}
              />
            )}
            <Tooltip 
              contentStyle={{ 
                borderRadius: '8px', 
                border: 'none', 
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)' 
              }}
              cursor={{ stroke: '#F97316', strokeWidth: 2 }}
            />
            <Area 
              type="monotone" 
              dataKey="value" 
              stroke="#F97316" 
              strokeWidth={3}
              fillOpacity={1} 
              fill="url(#colorValue)" 
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartSection;
